<template>
  <div class="no-parent-padding">
    <b-form class="no-shadow" @submit="onSubmit">
      <b-card no-body class="rounded-0">
        <b-card-header>
          <div class="d-flex justify-content-between align-items-center">
            <b>Configurações</b>

            <div class="d-flex flex-row-reverse">
              <b-button
                type="submit"
                variant="exitos"
                class="rounded-sm"
                :disabled="is_loading"
              >
                Salvar
              </b-button>
            </div>
          </div>
        </b-card-header>

        <b-overlay :show="is_loading" rounded="sm">
          <div class="p-3 p-md-4">
            <b-row>
              <h3 class="mx-3 mb-2">Assinatura</h3>
              <b-col cols="12" class="px-4 mx-0 mb-4">
                <b-row class="border rounded-lg pt-3">
                  <b-col cols="12" lg="6" class="mb-4">
                    <b-form-group label="Dias de Tolerância:">
                      <b-form-input
                        v-model="configuracoes.limite_dias_inadimplente"
                        type="number"
                        min="0"
                        step="1"
                        placeholder="Dias de Tolerância"
                        :state="validateState('limite_dias_inadimplente')"
                      />
                      <b-form-invalid-feedback
                        :state="validateState('limite_dias_inadimplente')"
                      >
                        <span
                          v-if="
                            v$.configuracoes.limite_dias_inadimplente.required
                              .$invalid
                          "
                        >
                          Campo obrigatório!
                        </span>
                        <span
                          v-else-if="
                            v$.configuracoes.limite_dias_inadimplente.min
                              .$invalid
                          "
                        >
                          O valor não pode ser menor que zero.
                        </span>
                      </b-form-invalid-feedback>
                      <b-form-text>
                        Determina a quantidade de dias de tolerância após o
                        vencimento antes de considerar a assinatura
                        inadimplente.
                      </b-form-text>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="6" class="mb-4">
                    <b-form-group label="Dias de Antecedência:">
                      <b-form-input
                        v-model="configuracoes.dias_antecedencia"
                        type="number"
                        min="0"
                        step="1"
                        placeholder="Dias de Antecedência"
                        :state="validateState('dias_antecedencia')"
                      />
                      <b-form-invalid-feedback
                        :state="validateState('dias_antecedencia')"
                      >
                        <span
                          v-if="
                            v$.configuracoes.dias_antecedencia.required.$invalid
                          "
                        >
                          Campo obrigatório!
                        </span>
                        <span
                          v-else-if="
                            v$.configuracoes.dias_antecedencia.min.$invalid
                          "
                        >
                          O valor não pode ser menor que zero.
                        </span>
                      </b-form-invalid-feedback>
                      <b-form-text>
                        Determina quantos dias antes da expiração do plano
                        (expira_at) o sistema deve gerar a fatura e
                        disponibilizar a renovação para pagamento.
                      </b-form-text>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="6" class="mb-4">
                    <b-form-group label="Dias de segurança:">
                      <b-form-input
                        v-model="configuracoes.dias_seguranca"
                        type="number"
                        min="0"
                        step="1"
                        placeholder="Dias de segurança"
                        :state="validateState('dias_seguranca')"
                      />
                      <b-form-invalid-feedback
                        :state="validateState('dias_seguranca')"
                      >
                        <span
                          v-if="
                            v$.configuracoes.dias_seguranca.required.$invalid
                          "
                        >
                          Campo obrigatório!
                        </span>
                        <span
                          v-else-if="
                            v$.configuracoes.dias_seguranca.min.$invalid
                          "
                        >
                          O valor não pode ser menor que zero.
                        </span>
                      </b-form-invalid-feedback>
                      <b-form-text>
                        Prazo após o vencimento para confirmar pagamento antes
                        do bloqueio automático.
                      </b-form-text>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="6" class="mb-4">
                    <b-form-group label="Dias de Vencimento:">
                      <b-form-input
                        v-model="configuracoes.dias_vencimento"
                        type="number"
                        min="1"
                        step="1"
                        placeholder="Dias de Vencimento"
                        :state="validateState('dias_vencimento')"
                      />
                      <b-form-invalid-feedback
                        :state="validateState('dias_vencimento')"
                      >
                        <span
                          v-if="
                            v$.configuracoes.dias_vencimento.required.$invalid
                          "
                        >
                          Campo obrigatório!
                        </span>
                        <span
                          v-else-if="
                            v$.configuracoes.dias_vencimento.min.$invalid
                          "
                        >
                          O valor não pode ser menor que um.
                        </span>
                      </b-form-invalid-feedback>
                      <b-form-text>
                        Determina o prazo de vencimento de novas cobranças e a
                        data de bloqueio de acesso.
                      </b-form-text>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>

              <h3 class="mx-3 mb-2">Tradução</h3>
              <b-col cols="12" class="mb-4 mx-0 px-4">
                <b-row class="border rounded-lg pt-3">
                  <b-col cols="12" lg="6" class="mb-4">
                    <b-form-group label="Teto de Caracteres por Tradução:">
                      <b-form-input
                        v-model="configuracoes.teto_caracteres_traducao"
                        type="number"
                        min="1"
                        step="1"
                        placeholder="Teto de Caracteres por Tradução"
                        :state="validateState('teto_caracteres_traducao')"
                      />
                      <b-form-invalid-feedback
                        :state="validateState('teto_caracteres_traducao')"
                      >
                        <span
                          v-if="
                            v$.configuracoes.teto_caracteres_traducao.required
                              .$invalid
                          "
                        >
                          Campo obrigatório!
                        </span>
                        <span
                          v-else-if="
                            v$.configuracoes.teto_caracteres_traducao.min
                              .$invalid
                          "
                        >
                          O valor não pode ser menor que um.
                        </span>
                      </b-form-invalid-feedback>
                      <b-form-text>
                        Determina o teto de consumo da api de traduções.
                      </b-form-text>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
        </b-overlay>
      </b-card>
    </b-form>
  </div>
</template>

<script>
import { deepCopy } from "@/helpers/functions/ObjectHelpers";
import { defineComponent, onMounted } from "vue";
import useVuelidate from "@vuelidate/core";
import { minValue, required } from "@vuelidate/validators";
import { useActions, useNamespacedState } from "vuex-composition-helpers";

import { useNotify } from "@/composables/useNotify";

export default defineComponent({
  name: "AssinaturasConfiguracoes",
  setup() {
    const assinaturaStates = useNamespacedState("assinaturas", [
      "configuracoes",
      "is_loading",
    ]);
    const { ActionShow, ActionSave } = useActions("assinaturas", [
      "ActionShow",
      "ActionSave",
    ]);
    const $notifications = useNotify();

    const rules = {
      configuracoes: {
        limite_dias_inadimplente: {
          min: minValue(1),
          required,
        },
        dias_antecedencia: {
          min: minValue(1),
          required,
        },
        dias_seguranca: {
          min: minValue(0),
          required,
        },
        dias_vencimento: {
          min: minValue(1),
          required,
        },
        teto_caracteres_traducao: {
          min: minValue(1),
          required,
        },
      },
    };
    const v$ = useVuelidate(rules, assinaturaStates);

    function validateState(name) {
      const { $dirty, $error } = v$.value.configuracoes[name];
      return $dirty ? !$error : null;
    }

    async function isValid() {
      return v$.value.$validate();
    }

    function transform(data) {
      const payload = deepCopy(data);

      payload.limite_dias_inadimplente = Number(
        payload.limite_dias_inadimplente
      );
      payload.dias_antecedencia = Number(payload.dias_antecedencia);
      payload.dias_seguranca = Number(payload.dias_seguranca);
      payload.dias_vencimento = Number(payload.dias_vencimento);
      payload.teto_caracteres_traducao = Number(
        payload.teto_caracteres_traducao
      );

      return payload;
    }

    async function onSubmit(event) {
      event.preventDefault();

      if (!(await isValid())) {
        $notifications.addNotification({
          message: "Dados inválidos, revise e tente novamente!",
          icon: "exclamation-triangle",
          type: "danger",
        });
        return;
      }

      try {
        const payload = transform(assinaturaStates.configuracoes.value);
        await ActionSave(payload);

        $notifications.addNotification({
          message: "Configurações salvas com sucesso",
          type: "success",
        });
      } catch (error) {
        $notifications.addNotification({
          message: "Erro ao salvar",
          icon: "exclamation-triangle",
          type: "danger",
        });
      }
    }

    onMounted(async () => {
      try {
        await ActionShow();
      } catch (error) {
        $notifications.addNotification({
          message:
            error?.data?.responseMessage || "Configurações não encontradas",
          icon: "exclamation-triangle",
          type: "danger",
        });
      }
    });

    return {
      ...assinaturaStates,
      v$,
      onSubmit,
      validateState,
    };
  },
});
</script>
